
export default {
  props: {
    totalPages: {
      type: Number,
      default: 0
    },
    currentPage: {
      type: Number,
      default: 1
    }
  },
  computed: {
    prevPage() {
      return this.currentPage > 1 ? this.currentPage - 1 : 1
    },
    nextPage() {
      return this.currentPage < this.totalPages
        ? this.currentPage + 1
        : this.totalPages
    },
    firstPage() {
      return 1
    },
    lastPage() {
      return this.totalPages
    },
    partialPages() {
      return this.calculatePaginationButtons(3)
    },
    pages() {
      if (this.totalPages > 10) {
        return this.calculatePaginationButtons(3)
      }
      return this.calculatePaginationButtons(10)
    }
  },
  methods: {
    calculatePaginationButtons(maxPages) {
      let startPage = 1
      let endPage = 1

      if (this.totalPages <= maxPages) {
        startPage = 1
        endPage = this.totalPages
      } else {
        const maxPagesBeforeCurrentPage = Math.floor(maxPages / 2)
        const maxPagesAfterCurrentPage =
          Math.floor(maxPages / 2) - (maxPages % 2 === 0 ? 1 : 0)
        if (this.currentPage <= maxPagesBeforeCurrentPage) {
          startPage = 1
          endPage = maxPages
        } else if (
          this.currentPage + maxPagesAfterCurrentPage >=
          this.totalPages
        ) {
          startPage = this.totalPages - maxPages + 1
          endPage = this.totalPages
        } else {
          startPage = this.currentPage - maxPagesBeforeCurrentPage
          endPage = this.currentPage + maxPagesAfterCurrentPage
        }
      }

      const pages = Array.from(Array(endPage + 1 - startPage).keys()).map(
        i => startPage + i
      )

      return pages
    },
    buttonClass(page) {
      return {
        "pagination-button": true,
        "pagination-button--active": this.currentPage === page,
        "pagination-button--hide-on-mobile": !this.partialPages.includes(page),
        "pagination-button--start":
          page === this.firstPage && page === this.currentPage,
        "pagination-button--end":
          page === this.lastPage && page === this.currentPage
      }
    }
  }
}
